export default "__VITE_ASSET__CRPL57mM__"